/* eslint-disable @typescript-eslint/no-shadow */
import { View, Text as PDFText } from '@react-pdf/renderer'

import { getCurrencyLabel } from '../../../../../helpers/currencies'
import { Currency } from '../../../../../types/currency'
import { addCommaToPrice } from '../../config/functions'
import styles from './styles/index.styles'

interface PriceAndNameProps {
  BookerName: string
  AfterTaxPrice: number
  Currency: Currency
  RefundAmount?: number
}

const PriceAndName = ({
  BookerName,
  AfterTaxPrice,
  Currency,
  RefundAmount = 0
}: PriceAndNameProps) => {
  return (
    <View style={styles.mainDiv}>
      <View style={styles.content}>
        <View style={styles.subject1}>
          <View style={styles.rowDirection}>
            <PDFText style={styles.subjectTitle}> :نام رزرو کننده </PDFText>
            <PDFText style={styles.subjectValue}>{BookerName}</PDFText>
          </View>
        </View>
        <View style={styles.subject2}>
          <View style={styles.rowDirection}>
            <PDFText style={styles.subjectTitle}> :قیمت کل </PDFText>
            <PDFText style={styles.subjectValue}>
              {addCommaToPrice(AfterTaxPrice)} {getCurrencyLabel(Currency)}
            </PDFText>
          </View>
          {/* Only shown when money is going back to the guest. */}
          {RefundAmount > 0 && (
            <View style={[styles.rowDirection, styles.refundRow]}>
              <PDFText style={styles.subjectTitle}> :مبلغ استرداد </PDFText>
              <PDFText style={styles.subjectValue}>
                {addCommaToPrice(RefundAmount)} {getCurrencyLabel(Currency)}
              </PDFText>
            </View>
          )}
        </View>
      </View>
    </View>
  )
}
export default PriceAndName
